import "./Css/QuestionList.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE from "../config/api";

const QuestionList = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [rejectReasons, setRejectReasons] = useState({
    wrongQuestion: false,
    incompleteInfo: false,
    invalidOption: false,
    explanation: "",
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingQuestions();
  }, []);

  const fetchPendingQuestions = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/questions/pending`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });

      const result = await res.json();

      const mapped = result.map((q, index) => ({
        id: q.id,
        std: q.standardName,
        subject: q.subject,
        chapter: q.topic,
        subChapter: q.subtopic,
        question: q.questionText,
        op1: q.optionA,
        op2: q.optionB,
        op3: q.optionC,
        op4: q.optionD,
        answer: q.correctAnswer,
        level: q.difficultyLevel,
        admin: q.submittedBy,
        date: new Date(q.createdAt).toLocaleDateString("hi-IN")
      }));

      setData(mapped);
    } catch (err) {
      console.error("Error loading questions:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = data.filter(q =>
    q.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    q.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
    q.chapter.toLowerCase().includes(searchQuery.toLowerCase())
  );



  return (
    <div className="question-wrapper">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}>
          प्रश्न संच &gt;&gt;<span>मंजुरीसाठी प्रश्नांची यादी</span>
        </h3>
      </div>

      <div className="filters">
        <div className="search-wrapper-exam">
          <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
            <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
          <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        </div>
        <select>
          <option> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12.0011 18.6947L6.00113 15.4332V10.587L3.07812 9.0025L12.0011 4.15625L20.9241 9.0025V15.3872H19.9241V9.564L18.0011 10.587V15.4332L12.0011 18.6947ZM12.0011 12.7025L18.8319 9.0025L12.0011 5.3025L5.17038 9.0025L12.0011 12.7025ZM12.0011 17.5545L17.0011 14.8545V11.137L12.0011 13.845L7.00113 11.137V14.8545L12.0011 17.5545Z" fill="#616161" />
          </svg>इयत्ता</option>
          <option>५ वी</option>
          <option>६ वी</option>
          <option>७ वी</option>
        </select>
        <select>
          <option> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5 18.2271V16.9964H13V17.9964L5 18.2271ZM5 14.4386V13.4386H19V14.4386H5ZM5 10.5541V9.55412H19V10.5541H5ZM5 6.99637V5.76562H19V6.99637H5Z" fill="#616161" />
          </svg>विषय</option>
          <option>मराठी</option>
          <option>English</option>
        </select>
      </div>

      {loading && <p style={{ padding: "20px" }}>Loading questions...</p>}

      <div className="table-container">
        <table className="question-table">
          <thead>
            <tr>
              <th>क्र.</th>
              <th>इयत्ता</th>
              <th>विषय</th>
              <th>घटक</th>
              <th>उपघटक</th>
              <th>प्रश्न</th>
              <th>पर्याय १</th>
              <th>पर्याय २</th>
              <th>पर्याय ३</th>
              <th>पर्याय ४</th>
              <th>उत्तर</th>
              <th>अ‍ॅडेड बाय (अ‍ॅडमिनचे नाव)</th>
              <th>सबमिट तारीख</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((q, index) => (
              <tr key={q.id} className="clickable-row" onClick={() => navigate(`/dashboard/question-view/${q.id}`)}>
                <td>{index + 1}</td>
                <td>{q.std}</td>
                <td>{q.subject}</td>
                <td>{q.chapter}</td>
                <td>{q.subChapter}</td>
                <td className="question-text">{q.question}</td>
                <td>{q.op1}</td>
                <td>{q.op2}</td>
                <td>{q.op3}</td>
                <td>{q.op4}</td>
                <td className="answer-cell">
                  {q.answer}
                  <span className="tick"> ✅</span>
                </td>
                <td>{q.admin}</td>
                <td>{q.date}</td>
                <td>
                  <button className="approve">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowPopup(true);
                      }}
                      width="17" height="13" viewBox="0 0 17 13" fill="none">
                      <path d="M5.7 12.025L0 6.325L1.425 4.9L5.7 9.175L14.875 0L16.3 1.425L5.7 12.025Z" fill="white" />
                    </svg>
                  </button>
                  <button className="reject">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowRejectPopup(true);
                      }}
                      width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="white" />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-icon">✔</div>

            <h3>“प्रश्न यशस्वीरित्या मंजूर केला आहे.”</h3>
            <p>
              हा प्रश्न प्रश्नसंचामध्ये जोडला गेले आहे    </p>

            <div className="popup-actions">
              <button className="outline-btn" onClick={() => navigate('/dashboard/quemanagment')}>
                प्रश्नसंचला जा
              </button>

              <button className="primary-btn" onClick={() => setShowPopup(false)}>
                ठीक आहे
              </button>
            </div>

            <span className="close-btn" onClick={() => setShowPopup(false)}>✕</span>
          </div>
        </div>
      )}

      {showRejectPopup && (
        <div className="popup-overlay">
          <div className="reject-popup-box">

            <span className="close-btn" onClick={() => setShowRejectPopup(false)}>✕</span>

            <div className="reject-icon">✖</div>

            <h3>नकाराचे कारण निवडा</h3>

            <div className="checkbox-group">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setRejectReasons({ ...rejectReasons, wrongQuestion: e.target.checked })
                  }
                />
                चुकीचा प्रश्न
              </label>

              <label>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setRejectReasons({ ...rejectReasons, incompleteInfo: e.target.checked })
                  }
                />
                अपूर्ण माहिती
              </label>

              <label>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setRejectReasons({ ...rejectReasons, invalidOption: e.target.checked })
                  }
                />
                पर्याय चुकीचे आहेत
              </label>
            </div>

            <textarea
              placeholder="इतर (स्पष्टीकरण)"
              value={rejectReasons.explanation}
              onChange={(e) =>
                setRejectReasons({ ...rejectReasons, explanation: e.target.value })
              }
            />

            <button className="reject-submit-btn" onClick={() => setShowRejectPopup(false)}>
              प्रश्न नकार
            </button>

          </div>
        </div>
      )}

    </div>
  );
};

export default QuestionList;
